import { jsxs as i, jsx as r } from "react/jsx-runtime";
import { T as e } from "./Typography-HkIo7ajX.js";
import { Stack as o, Link as t } from "@mui/material";
import { s as n } from "./spacings-C27fg6SF.js";
const g = ({ privacyPolicyLink: s = "", termsLink: a = "" }) => /* @__PURE__ */ i(
  o,
  {
    display: "flex",
    direction: "row",
    flexWrap: "wrap",
    justifyContent: "center",
    spacing: n.xxs,
    children: [
      /* @__PURE__ */ i(
        e,
        {
          variant: "text",
          size: "sm",
          color: "grey.600",
          children: [
            "By using Guidde you are agreeing to our",
            " "
          ]
        }
      ),
      /* @__PURE__ */ i(
        o,
        {
          direction: "row",
          spacing: n.xxs,
          children: [
            /* @__PURE__ */ r(
              t,
              {
                href: s,
                target: "_blank",
                color: "grey.600",
                children: /* @__PURE__ */ r(
                  e,
                  {
                    variant: "text",
                    size: "sm",
                    color: "grey.600",
                    fontWeight: "medium",
                    children: "privacy policy"
                  }
                )
              }
            ),
            /* @__PURE__ */ r(
              e,
              {
                variant: "text",
                size: "sm",
                color: "grey.600",
                children: "and"
              }
            ),
            /* @__PURE__ */ r(
              t,
              {
                href: a,
                target: "_blank",
                color: "grey.600",
                children: /* @__PURE__ */ r(
                  e,
                  {
                    variant: "text",
                    size: "sm",
                    color: "grey.600",
                    fontWeight: "medium",
                    children: "terms."
                  }
                )
              }
            )
          ]
        }
      )
    ]
  }
);
export {
  g as P
};
